import { Component, Input } from '@angular/core';
import { DialogService } from '../../../services/dialog/dialog.service';

@Component({
  selector: 'psc-value-text',
  templateUrl: './value-text.component.html'
})
export class ValueTextComponent {
  @Input()
  set numberOfDecimals(value: number | undefined) {
    if (value === undefined) {
      return;
    }
    this.digitsInfo = `1.0-${ value }`;
  }

  @Input() coloredRow: boolean = false;
  @Input() label: string;
  @Input() value: string | number | undefined | null;
  @Input() stringValue: string | undefined | null;
  @Input() secondValue: string | number | undefined;
  @Input() unit: string;
  @Input() titleSize: 'text-3xl' | 'text-4xl' | '' = '';
  @Input() inline: boolean = true;
  @Input() infoText: string | undefined;
  @Input() coloredRowColor: string = 'bg-yellow2';
  @Input() primaryTextColor: string = 'text-blue1';
  @Input() secondaryTextColor: string = 'text-sun-yellow';

  digitsInfo = '1.0-2';
  showInfoDialog: boolean;

  constructor(
    public dialogService: DialogService,
  ) {
  }
}
